<ion-list mode="ios" lines="none" class="ion-no-margin list-content">
  <ng-container *ngIf="heart">
    <ion-img
      [src]="'Icons.heart-life-shadow' | translate"
      class="heart-life-shadow animated fadeIn fast"
    ></ion-img>
  </ng-container>

  <ion-card mode="ios" color="white-grad" class="card-content">
    <ion-item
      mode="md"
      lines="none"
      color="transparent"
      class="ion-text-center"
    >
      <ion-label
        mode="md"
        color="darkblue"
        class="mpe-font-weight-600 heres-gift"
      >
        <p class="need-lives-play">
          {{ 'Labels.need-lives-play' | translate }}
        </p>
        {{ 'Labels.heres-gift' | translate }}
      </ion-label>
    </ion-item>

    <ion-item
      mode="md"
      lines="none"
      color="transparent"
      class="ion-text-center"
    >
      <ion-label mode="md" color="status-icon-enable" class="more-life">
        {{ 'Labels.more-life' | translate }}
      </ion-label>
    </ion-item>

    <ion-item
      mode="md"
      lines="none"
      color="transparent"
      class="ion-text-center"
    >
      <ion-label
        mode="md"
        color="status-icon-enable"
        class="remember-return-daily-receive-lives-gift"
      >
        {{ 'Labels.remember-return-daily-receive-lives-gift' | translate }}
      </ion-label>
    </ion-item>

    <ion-item mode="md" lines="none" color="transparent">
      <ion-button
        class="button-play mpe-font-weight-600"
        size="default"
        mode="md"
        color="white-grad"
        (click)="onClose()"
      >
        <ion-icon
          slot="start"
          [src]="'Icons.play-button' | translate"
        ></ion-icon>

        <ion-label mode="md"> {{ "Buttons.to-play" | translate }} </ion-label>
      </ion-button>
    </ion-item>
  </ion-card>
</ion-list>
